/* ============================================================================
 * rift-preview-url.js — build the stained-preview URL for a Rift cart line.
 *
 * Same process as cabinet-preview-url.js, which does this for Custom Inset.
 * Read that file first: the rules here are its rules, and they are not
 * optional.
 *
 *   https://opcabinets.com/api/v1/cabinet-preview?src=<photo>&rift=CHARCOAL&w=600
 *
 * The preview is rendered ON DEMAND from the URL itself. Nothing is uploaded
 * and nothing is stored, which is what lets an emailed confirmation or a
 * printed invoice show the stained cabinet: those surfaces cannot run
 * JavaScript, so they need a plain <img src> that resolves on its own.
 *
 * DETERMINISM IS THE WHOLE POINT. Shopify treats line item properties as part
 * of a line's identity, so two cabinets whose _Preview differs will NOT merge
 * into one x2 line. The same cabinet in the same stain must produce a
 * byte-identical URL from every caller, which is why canonical() strips
 * Shopify's ?v= cache-buster and its _300x-style size suffixes: those differ
 * between the product page and /cart.js for the very same photo and would
 * otherwise split one line in two.
 *
 * It asks for rift= rather than stain= because a Rift render has no orange
 * placeholder box: stain= is the White Oak Inset mode and would hand back the
 * photo unstained. See lib/server/rift-render.ts.
 *
 * Every caller MUST go through this file.
 * ==========================================================================*/
window.RTARiftPreview = (function () {
  'use strict';

  var BASE = window.RTA_PREVIEW_BASE || 'https://opcabinets.com/api/v1/cabinet-preview';
  var WIDTH = window.RTA_PREVIEW_WIDTH || 600;

  /** Same photo, one spelling: drop ?v=… and any _WxH / _600x size suffix. */
  function canonical(src) {
    if (!src) return '';
    var u = String(src).split('?')[0].split('#')[0];
    if (u.indexOf('//') === 0) u = 'https:' + u;          // protocol-relative
    return u.replace(
      /_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(?=\.[a-z]+$)/i,
      ''
    );
  }

  /** "Charcoal" or "Charcoal stain" → "CHARCOAL", or null when not a Rift stain. */
  function codeFor(label) {
    if (!label) return null;
    var name = String(label).replace(/\s+stain$/i, '').trim().toUpperCase();
    var known = window.RTA_RIFT_STAINS;
    if (known && known.length) {
      for (var i = 0; i < known.length; i++) {
        if (String(known[i]).toUpperCase() === name) return name;
      }
      return null;                                        // unknown: no preview
    }
    return /^[A-Z]+$/.test(name) ? name : null;
  }

  /**
   * @param {string} photoSrc the cabinet photo (product page or /cart.js item.image)
   * @param {string} stain    the stain, with or without the " stain" suffix
   * @returns {string} preview URL, or '' when there is nothing to render
   */
  function url(photoSrc, stain) {
    var photo = canonical(photoSrc);
    var code = codeFor(stain);
    if (!photo || !code) return '';
    return BASE +
      '?src=' + encodeURIComponent(photo) +
      '&rift=' + encodeURIComponent(code) +
      '&w=' + WIDTH;
  }

  return { url: url, canonical: canonical, codeFor: codeFor };
})();
